import React, { Component } from 'react';
import style from '../../style/style';
import LineChart from '../linechart';
import Loading from '../loading';
import toTitleCase from '../../utils/toTitleCase';

class Rent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    const data = { ...this.props };
    const area = toTitleCase(data.data.LE_ENGLISH);
    const rentArr = []
    if (!isNaN(parseInt(data.data["2016_Q4"]))) {
      rentArr.push({x: 0, y: parseInt(data.data["2016_Q4"])});
    }
    if (!isNaN(parseInt(data.data["2017_Q1"]))) {
      rentArr.push({x: 1, y: parseInt(data.data["2017_Q1"])});
    }
    if (!isNaN(parseInt(data.data["2017_Q2"]))) {
      rentArr.push({x: 2, y: parseInt(data.data["2017_Q2"])});
    }
    if (!isNaN(parseInt(data.data["2017_Q3"]))) {
      rentArr.push({x: 3, y: parseInt(data.data["2017_Q3"])});
    }
    
    const currentPrice = rentArr[rentArr.length -1];

    return (
      <div 
        style={{ ...style.fact.layout }}
      > 
        <div style={{ ...style.fact.left, paddingTop: "0.5rem" }}>
          <LineChart
            data = {rentArr}
          />
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ ...style.fact.heading, marginBottom: 0 }}>
            { `€${currentPrice.y} average rent` }
          </h2>
          <p style={{ marginTop: 0 }}>{`In the greater ${area} area`}</p>
          <div style={{ ...style.fact.source }}>Source: Rent index Q3 2017, <a href="https://www.rtb.ie/">rtb.ie</a>.</div>
        </div>
      </div>);
  }
}

export default Rent;



// WEBPACK FOOTER //
// ./src/components/rent/index.js